<template>
  <el-form
    :model="form"
    :rules="rules"
    ref="form"
    label-position="left"
    label-width="200px"
  >
    <el-row :gutter="24">
      <el-col :span="24">
        <el-form-item label="Lãnh đạo đ/v phụ trách" prop="phuTrachCap1Id">
          <el-select
            class="style-fullWidth input-border__bottom input-border__radius__0"
            v-model="form.phuTrachCap1Id"
            placeholder="Lãnh đạo đ/v phụ trách"
            size="medium"
            filterable
            clearable
            @change="phuTrachCap1IdChanged"
          >
            <el-option
              v-for="item in lanhDaoDonVi"
              :key="item.id"
              :label="
                `${item.fullName} (${item.positionName} - ${item.deptName})`
              "
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <!--        </el-row>-->

      <!--        <el-row :gutter="24">-->
      <el-col :span="24">
        <el-form-item label="Chuyên viên đ/v phụ trách" prop="phuTrachCap2Id">
          <el-select
            class="style-fullWidth input-border__bottom input-border__radius__0"
            v-model="form.phuTrachCap2Id"
            placeholder="Chuyên viên đ/v phụ trách"
            size="medium"
            filterable
            clearable
          >
            <el-option
              v-for="item in chuyenVienDonVi"
              :key="item.id"
              :label="
                `${item.fullName} (${item.positionName} - ${item.deptName})`
              "
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <!--        </el-row>-->

      <!--        <el-row :gutter="24">-->
      <el-col :span="16">
        <el-form-item label="Tiến độ xử lý" prop="commandsStatus">
          <el-select
            class="style-fullWidth input-border__bottom input-border__radius__0"
            v-model="form.commandsStatus"
            placeholder="Tiến độ xử lý"
            size="medium"
            filterable
            clearable
            @change="commandsStatusChanged"
            :disabled="form.isDuplicate"
          >
            <el-option
              v-for="item in commandStatusSelectOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <!--        </el-row>-->

      <!--        <el-row :gutter="24">-->
      <el-col :span="24">
        <hc-cong-viec-trong-tam-doc-relations
          v-if="!!hcCVTrongTam"
          ref="hcCVTrongTamDocRelationsRef"
          :objectId="hcCVTrongTam.id"
          :objectType="HC_DOC_RELATION.OBJECT_TYPE.HC_CONGVIECTRONGTAM"
          :deptId="hcCVTrongTam.deptId"
          @docSelected="relatedDocSelected"
        />
      </el-col>
      <!--        </el-row>-->

      <!--        <el-row :gutter="24">-->
      <el-col :span="16">
        <el-form-item label="Ngày hoàn thành" prop="completeDate">
          <el-date-picker
            v-model="form.completeDate"
            type="date"
            size="medium"
            class="style-fullWidth input-border__bottom input-border__radius__0"
            placeholder="dd/mm/yyyy"
            format="dd/MM/yyyy"
          >
          </el-date-picker>
        </el-form-item>
      </el-col>
      <!--        </el-row>-->

      <!--        <el-row :gutter="24">-->
      <el-col :span="24">
        <el-form-item
          label="Báo cáo kết quả thực hiện"
          prop="progressImplement"
        >
          <el-input
            v-model="form.progressImplement"
            type="textarea"
            placeholder="Báo cáo kết quả thực hiện"
            class="input-border__bottom input-border__radius__0 style-fullWidth"
            size="medium"
            show-word-limit
            maxlength="5000"
          ></el-input>
        </el-form-item>
      </el-col>
      <!--        </el-row>-->

      <!--        <el-row :gutter="24">-->
      <el-col :span="24">
        <el-form-item label="Lý do chậm tiến độ (nếu có)" prop="conclusion">
          <el-input
            v-model="form.lateReason"
            type="textarea"
            placeholder="Lý do chậm tiến độ (nếu có)"
            class="input-border__bottom input-border__radius__0 style-fullWidth"
            size="medium"
            show-word-limit
            maxlength="5000"
          ></el-input>
        </el-form-item>
      </el-col>
      <!--        </el-row>-->

      <!--        <el-row :gutter="24">-->
      <el-col :span="24">
        <el-form-item label="Chỉ đạo trùng" prop="isDuplicate">
          <el-checkbox
            v-model="form.isDuplicate"
            @change="isDuplicateChange"
          ></el-checkbox>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import dateUtils from "../../../dateUtils";
import CustomDialog from "../../common/custom-dialog";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import hanhChinhUtils from "../../../services/hanhChinhUtils";
import Vue from "vue";
import userDeptRoleViewService from "../../../services/userDeptRoleViewService";
import constants from "../../../constants";
import utils from "../../../services/utils";
import h from "../../../services/h";
import HcCongViecTrongTamDocRelations from "./hc-congviectrongtam-doc-relations";
import hcCVTrongTamService from "../../../services/congviectrongtam/hcCVTrongTamService";
import hcCVTrongTamUserService from "../../../services/congviectrongtam/hcCVTrongTamUserService";

export default {
  name: "hc-congviectrongtam-bao-cao-form",
  props: ["isOpen", "id"],
  mixins: [handleRequestErrorMixin],
  components: { HcCongViecTrongTamDocRelations, CustomDialog },

  data() {
    return {
      form: {
        phuTrachCap1Id: null,
        phuTrachCap2Id: null,
        commandsStatus: null,
        completeDate: null,
        progressImplement: null,
        lateReason: null,
        isDuplicate: false
      },
      originalForm: {
        phuTrachCap1Id: null,
        phuTrachCap2Id: null,
        commandsStatus: null,
        completeDate: null,
        progressImplement: null,
        lateReason: null,
        isDuplicate: false
      },
      rules: {
        phuTrachCap1Id: null,
        phuTrachCap2Id: null,
        commandsStatus: null,
        completeDate: null,
        progressImplement: null,
        lateReason: null
      },
      hcCVTrongTam: null,
      lanhDaoDonVi: null,
      chuyenVienDonVi: null,
      commandStatusSelectOptions: null,
      HC_DOC_RELATION: constants.HC_DOC_RELATION
    };
  },

  watch: {
    id() {
      this.reloadPage();
    }
  },

  async created() {
    this.initSelectOptions();
    await this.loadHcCVTrongTam();
    await this.loadHcCVTrongTamUsers().then(hcCVTrongTamUsers => {
      this.initForm(hcCVTrongTamUsers, this.form);
      this.initForm(hcCVTrongTamUsers, this.originalForm);
      this.initValidationRules();
    });
    await this.loadLanhDaoDonVi();
    await this.loadChuyenVienDonVi();
  },

  methods: {
    async reloadPage() {
      //reset lại data;
      this.form = {
        phuTrachCap1Id: null,
        phuTrachCap2Id: null,
        commandsStatus: null,
        completeDate: null,
        progressImplement: null,
        lateReason: null,
        isDuplicate: false
      };
      this.originalForm = {
        phuTrachCap1Id: null,
        phuTrachCap2Id: null,
        commandsStatus: null,
        completeDate: null,
        progressImplement: null,
        lateReason: null,
        isDuplicate: false
      };
      this.rules = {
        phuTrachCap1Id: null,
        phuTrachCap2Id: null,
        commandsStatus: null,
        completeDate: null,
        progressImplement: null,
        lateReason: null
      };
      this.hcCVTrongTam = null;
      this.lanhDaoDonVi = null;
      this.chuyenVienDonVi = null;

      await this.loadHcCVTrongTam();
      await this.loadHcCVTrongTamUsers().then(hcCVTrongTamUsers => {
        this.initForm(hcCVTrongTamUsers, this.form);
        this.initForm(hcCVTrongTamUsers, this.originalForm);
        this.initValidationRules();
      });
      await this.loadLanhDaoDonVi();
      await this.loadChuyenVienDonVi();
    },

    isDataChanged() {
      return (
        this.form.phuTrachCap1Id !== this.originalForm.phuTrachCap1Id ||
        this.form.phuTrachCap2Id !== this.originalForm.phuTrachCap2Id ||
        this.form.commandsStatus !== this.originalForm.commandsStatus ||
        dateUtils.isDiff(
          this.form.completeDate,
          this.originalForm.completeDate
        ) ||
        this.form.progressImplement !== this.originalForm.progressImplement ||
        this.form.lateReason !== this.originalForm.lateReason ||
        this.form.isDuplicate !== this.originalForm.isDuplicate ||
        (this.$refs.hcCVTrongTamDocRelationsRef &&
          this.$refs.hcCVTrongTamDocRelationsRef.isDataChanged())
      );
    },

    relatedDocSelected(event) {
      let relatedDoc = event.relatedDoc;
      if (
        relatedDoc.referenceObjectType ===
        constants.HC_DOC_RELATION.REFERENCE_OBJECT_TYPE.VB_OUTGOING_DOC
      ) {
        this.form.completeDate = relatedDoc.docDate;
      }
    },

    isDuplicateChange() {
      this.form.commandsStatus =
        constants.HC_CONGVIECTRONGTAM.COMMAND_STATUS.COMPLETE;
      this.commandsStatusChanged();
    },

    loadHcCVTrongTamUsers() {
      return hcCVTrongTamUserService
        .findByHcCongViecTrongTamId(this.hcCVTrongTam.id)
        .then(response => response.data);
    },

    initForm(hcCVTrongTamUsers, form) {
      form.isDuplicate = this.hcCVTrongTam.isDuplicate === constants.TRUE;
      form.commandsStatus = this.hcCVTrongTam.commandsStatus;
      form.completeDate = this.hcCVTrongTam.completeDate
        ? new Date(this.hcCVTrongTam.completeDate)
        : null;
      form.progressImplement = this.hcCVTrongTam.progressImplement;
      form.lateReason = this.hcCVTrongTam.lateReason;

      h.each(hcCVTrongTamUsers, hcCVTrongTamUsers => {
        switch (hcCVTrongTamUsers.type) {
          case constants.HC_CONGVIECTRONGTAM_USER.TYPE.PHU_TRACH_CAP1:
            form.phuTrachCap1Id = hcCVTrongTamUsers.userId;
            break;
          case constants.HC_CONGVIECTRONGTAM_USER.TYPE.PHU_TRACH_CAP2:
            form.phuTrachCap2Id = hcCVTrongTamUsers.userId;
            break;
        }
      });
    },

    phuTrachCap1IdChanged() {
      this.$refs.form.validateField("phuTrachCap1Id");
    },

    commandsStatusChanged() {
      this.initValidationRulesByCommandsStatus();
      this.$refs.form.validateField("commandsStatus");
      this.$refs.form.clearValidate("completeDate");
      this.$refs.form.clearValidate("progressImplement");
    },

    initSelectOptions() {
      this.commandStatusSelectOptions = hanhChinhUtils.buildHcCongViecTrongTamStatusOptions();
    },

    loadHcCVTrongTam() {
      return hcCVTrongTamService
        .findById(this.id)
        .then(response => (this.hcCVTrongTam = response.data));
    },

    loadLanhDaoDonVi() {
      return userDeptRoleViewService
        .findAllLDDVForHcCommands(this.hcCVTrongTam.deptId)
        .then(response => (this.lanhDaoDonVi = response.data));
    },

    loadChuyenVienDonVi() {
      return userDeptRoleViewService
        .findAllCVDVForHcCommands(this.hcCVTrongTam.deptId)
        .then(response => {
          this.chuyenVienDonVi = (response.data || []).sort((user1, user2) =>
            utils.compareUserDeptRoleView(user1, user2)
          );
        });
    },

    chuTriDeptIdsChanged() {
      this.$refs.form.validateField("chuTriDeptIds");
    },

    initValidationRules() {
      let defaultRequiredConstrains = {
        required: true,
        message: "Trường dữ liệu bắt buộc",
        trigger: "blur"
      };
      Vue.set(this.rules, "phuTrachCap1Id", [defaultRequiredConstrains]);
      Vue.set(this.rules, "commandsStatus", [defaultRequiredConstrains]);
      this.initValidationRulesByCommandsStatus();
      if (this.$refs.form) this.$refs.form.clearValidate();
    },

    initValidationRulesByCommandsStatus() {
      if (
        this.form.commandsStatus ===
        constants.HC_CONGVIECTRONGTAM.COMMAND_STATUS.COMPLETE
      ) {
        let defaultRequiredConstrains = {
          required: true,
          message: "Trường dữ liệu bắt buộc",
          trigger: "blur"
        };
        Vue.set(this.rules, "completeDate", [defaultRequiredConstrains]);
        Vue.set(this.rules, "progressImplement", [defaultRequiredConstrains]);

        if(!this.$refs.hcCVTrongTamDocRelationsRef.hasRelationDocs()) {
          this.$refs.hcCVTrongTamDocRelationsRef.changeValidate(true);
        } else {
          this.$refs.hcCVTrongTamDocRelationsRef.changeValidate(false);
        }
      } else {
        Vue.set(this.rules, "completeDate", null);
        Vue.set(this.rules, "progressImplement", null);
        this.$refs.hcCVTrongTamDocRelationsRef.changeValidate(false);
      }
    },

    convertToSubmitForm() {
      let docRelationForms = this.$refs.hcCVTrongTamDocRelationsRef.getSubmitForms();
      return {
        isDuplicate: this.form.isDuplicate ? constants.TRUE : constants.FALSE,
        phuTrachCap1Id: this.form.phuTrachCap1Id,
        phuTrachCap2Id: this.form.phuTrachCap2Id,
        commandsStatus: this.form.commandsStatus,
        completeDate: this.form.completeDate
          ? this.form.completeDate.getTime()
          : null,
        progressImplement: this.form.progressImplement,
        lateReason: this.form.lateReason,
        docRelationForms: docRelationForms
      };
    },

    validateForm() {
      return new Promise(resolve => {
        this.initValidationRulesByCommandsStatus();
        resolve();
      }).then(() => utils.validateFormCommon(this.$refs.form, this.$message))
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/adminstration/congviectrongtam/hc-congviectrongtam-bao-cao-form.vue